import React, { useRef, useState, useCallback } from "react";
import Placeholder from "./Placeholder";

export const BeforeAfterSlider = ({
  beforeLabel = "Before · Phone snap",
  afterLabel = "After · On-location shoot",
  ratio = "16/10",
}) => {
  const [pos, setPos] = useState(45);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, clientX - rect.left));
    setPos((x / rect.width) * 100);
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onUp = () => (dragging.current = false);

  return (
    <div
      data-testid="before-after"
      ref={ref}
      className="relative overflow-hidden select-none cursor-ew-resize touch-none"
      style={{ aspectRatio: ratio }}
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      {/* After (full) */}
      <div className="absolute inset-0">
        <Placeholder variant="warm" ratio={ratio} label={afterLabel} className="h-full w-full" />
      </div>
      {/* Before (clipped) */}
      <div
        className="absolute inset-y-0 left-0 overflow-hidden"
        style={{ width: `${pos}%` }}
      >
        <div className="h-full" style={{ width: `${ref.current?.clientWidth || 800}px` }}>
          <Placeholder variant="cool" ratio={ratio} label={beforeLabel} className="h-full w-full" />
        </div>
      </div>

      {/* Divider */}
      <div
        className="absolute top-0 bottom-0 w-px bg-bone/90 pointer-events-none"
        style={{ left: `${pos}%` }}
      >
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 left-0 w-10 h-10 rounded-full bg-bone text-ink flex items-center justify-center shadow-2xl">
          <span className="font-mono text-[9px] uppercase tracking-wider2">⇄</span>
        </div>
      </div>

      {/* Labels */}
      <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-wider3 text-bone/80">
        Before
      </span>
      <span className="absolute top-4 right-4 font-mono text-[10px] uppercase tracking-wider3 text-bone">
        After
      </span>
    </div>
  );
};

export default BeforeAfterSlider;
